import { useState } from 'react';

import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { Sort } from 'iconsax-react';

import { orderingValues } from 'constants/search-sort.const';

import classes from './ExploreContentWrapper.module.scss';

import Tick from 'assets/icons/tick.svg';

const ExploreContentWrapper = ({
	selectedContent,
	selectedOrdering,
	handleContentTypeSelect,
	handleOrderingChange,
	resultCount
}) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleClickOrder = (newOrder) => {
		handleOrderingChange(newOrder);
		handleClose();
	};

	return (
		<div className="d-flex flex-column">
			<div className="d-flex flex-row flex-wrap align-items-center justify-content-between">
				<div className="d-flex flex-row gap-3">
					{/* <Chip
						onClick={() => handleContentTypeSelect('all')}
						label="All"
						clickable
						color={!selectedContent ? 'primary' : undefined}
					/>
					<Chip
						onClick={() => handleContentTypeSelect('course')}
						label="Job Qualifications"
						clickable
						color={selectedContent === 'course' ? 'primary' : undefined}
					/>
					<Chip
						onClick={() => handleContentTypeSelect('lecture')}
						label="Courses"
						clickable
						color={selectedContent === 'lecture' ? 'primary' : undefined}
					/> */}
				</div>
				{resultCount !== 0 && (
					<div className="d-none d-lg-block">
						<Button
							id="sort-button"
							variant="text"
							aria-controls={!!anchorEl ? 'basic-menu' : undefined}
							aria-haspopup="true"
							aria-expanded={!!anchorEl ? 'true' : undefined}
							onClick={handleClick}>
							<Sort size="24" color="#000000" variant="TwoTone" style={{ marginRight: '12px' }} />
							<span
								style={{
									fontSize: '18px',
									fontWeight: '700',
									color: '#0D0D0D',
									textTransform: 'none'
								}}>
								Sort By
							</span>
						</Button>
						<Menu
							id="basic-menu"
							anchorEl={anchorEl}
							anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
							transformOrigin={{ vertical: 'top', horizontal: 'right' }}
							open={!!anchorEl}
							onClose={handleClose}
							className={classes['sort-by-desktop-wrapper']}
							MenuListProps={{
								'aria-labelledby': 'basic-button'
							}}>
							{orderingValues.map((orderVal) => {
								return (
									<MenuItem key={orderVal.value} onClick={() => handleClickOrder(orderVal.value)}>
										{selectedOrdering === orderVal.value && (
											<Tick style={{ marginRight: '8px' }} />
										)}
										{orderVal.name}
									</MenuItem>
								);
							})}
						</Menu>
					</div>
				)}

			</div>
		</div>
	);
};

export default ExploreContentWrapper;
